// eslint-disable-next-line no-extend-native
String.prototype.endsWith = function (s) {
  return this.length >= s.length && this.substr(this.length - s.length) === s;
}
